import React, { Component } from 'react';
import { Configuration, getDataTable } from './Configuration';

const ICON_MAP = {
  'IMPORT': 'fa-upload',
  'EXPORT': 'fa-download',
  'IMAGE IDENTIFICATION': 'fa-th-large',
  'REPORT': 'fa-bar-chart',
  'UPDATE PORTAL': 'fa-refresh',
  'TEMPLATE MASTER': 'fa-file-text-o',
  'ALIASING': 'fa-exchange',
  'IMAGE EXTRACTOR': 'fa-picture-o',
  'METADATA': 'fa-magic',
  'PORTAL IMAGE': 'fa-check-circle-o',
  'PORTAL DATA': 'fa-check-square-o',
  'MASTER DATA': 'fa-database',
  'EXCEL IMAGE': 'fa-table',
  // Matched by "NAMSHI CREDENTIALS"; no other menu name contains "CREDENTIAL",
  // so this cannot steal an icon from an existing entry.
  'CREDENTIAL': 'fa-key',
  'SHEET': 'fa-table',
  'TRACKER': 'fa-link',
  'AUDIT': 'fa-tasks',
  'CATALOG QUALITY': 'fa-check-square',
};

function getMenuIcon(name) {
  const n = (name || '').toUpperCase();
  for (const [key, icon] of Object.entries(ICON_MAP)) {
    if (n.includes(key)) return icon;
  }
  return 'fa-circle-o';
}

function getMenuGroup(name) {
  const n = (name || '').toUpperCase();
  if (n.includes('TEMPLATE') || n.includes('ALIASING')) return 'TEMPLATES';
  if (
    n.includes('EXTRACTOR') || n.includes('METADATA') ||
    n.includes('EXCEL IMAGE') || n.includes('MASTER DATA') ||
    n.includes('PORTAL IMAGE') || n.includes('PORTAL DATA') ||
    n.includes('AUDIT') || n.includes('CATALOG QUALITY')
  ) return 'IMAGE TOOLS';
  return 'MAIN NAVIGATION';
}

const GROUP_ORDER = ['MAIN NAVIGATION', 'TEMPLATES', 'IMAGE TOOLS'];

class Menu extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.updateHash = this.updateHash.bind(this);
  }

  state = {
    menuItems: [],
    menuList: [],
    isLoaded: false,
    orgname: '',
    currentHash: window.location.hash.replace('#/', '').toLowerCase(),
  };

  componentDidMount() {
    window.addEventListener('hashchange', this.updateHash);
    this.setState({ loginId: Configuration.USER_ID });
    this.handleClick(Configuration.USER_ID);
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.updateHash);
  }

  updateHash() {
    this.setState({ currentHash: window.location.hash.replace('#/', '').toLowerCase() });
  }

  async handleClick(val) {
    let Query = '';
    if (val === '1') {
      Query = "SELECT DISTINCT MenuId, MenuName, Path AS url, 'ALL' AS Rights, loginID AS userid, Priority FROM Menu where Dis = 0 order by Priority";
    } else {
      Query = "SELECT distinct Menu.MenuId, Menu.MenuName, Menu.Path as url, UserRights.Rights, UserRights.userID, Priority FROM UserRights INNER JOIN Menu ON UserRights.menuID = Menu.MenuId WHERE (UserRights.userID = " + val + ") and Rights <> 'None' and Menu.DIS = 0 order by Priority";
    }
    const response = await getDataTable(Query);
    const cqcItem = { MenuId: 9999, MenuName: 'Catalog Quality Check', url: 'frmCatalogQualityCheck', Rights: 'ALL', Priority: 998 };
    const hasCqc = response.some(m => m.url === 'frmCatalogQualityCheck');
    const menuList = response.length > 0 ? (hasCqc ? response : [...response, cqcItem]) : [cqcItem];
    this.setState({ menuList, loading: false });
  }

  myFunction(e) {
    const filter = e.target.value.toUpperCase();
    const ul = document.getElementById('myUL');
    if (!ul) return;
    const li = ul.getElementsByTagName('li');
    for (let i = 0; i < li.length; i++) {
      const a = li[i].getElementsByTagName('a')[0];
      if (!a) continue;
      const txtValue = a.textContent || a.innerText;
      li[i].style.display = txtValue.toUpperCase().indexOf(filter) > -1 ? '' : 'none';
    }
  }

  render() {
    const { menuList, loading, currentHash } = this.state;

    if (loading) return <span />;

    // Group menu items
    const grouped = {};
    GROUP_ORDER.forEach(g => { grouped[g] = []; });

    menuList.forEach(item => {
      const g = getMenuGroup(item.MenuName);
      grouped[g].push(item);
    });

    return (
      <div>
        <aside className="main-sidebar">
          <section className="sidebar">
            <div className="user-panel">
              <div className="pull-left image">
                <img src="dist/img/avatar5.png" className="img-circle" alt="User" />
              </div>
              <div className="pull-left info">
                <p>{Configuration.USER_NAME}</p>
                <span><i className="fa fa-circle text-success" /> Online</span>
              </div>
            </div>

            <form method="get" className="sidebar-form">
              <div className="input-group">
                <input
                  type="text"
                  name="q"
                  id="myInput"
                  onKeyUp={this.myFunction.bind(this)}
                  autoComplete="off"
                  className="form-control"
                  placeholder="Search..."
                />
                <span className="input-group-btn">
                  <button type="submit" name="search" id="search-btn" className="btn btn-flat">
                    <i className="fa fa-search" />
                  </button>
                </span>
              </div>
            </form>

            <ul className="sidebar-menu" id="myUL" data-widget="tree">
              {GROUP_ORDER.map(group => {
                const items = grouped[group];
                if (!items.length) return null;
                return (
                  <React.Fragment key={group}>
                    <li className="sidebar-group-header">{group}</li>
                    {items.map((value, index) => {
                      const isActive = currentHash === value.url.toLowerCase();
                      const icon = getMenuIcon(value.MenuName);
                      return (
                        <li
                          className={`nav-item${isActive ? ' active' : ''}`}
                          key={index}
                        >
                          <a
                            href={'#/' + value.url}
                            className={isActive ? 'active-link' : ''}
                          >
                            <i className={`fa ${icon} nav-icon`} />
                            <span className="nav-label">{value.MenuName}</span>
                          </a>
                        </li>
                      );
                    })}
                  </React.Fragment>
                );
              })}
            </ul>
          </section>
        </aside>
      </div>
    );
  }
}

export default Menu;
